import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {URLS} from '../../environments/environment';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class VehicleInfoService {

  constructor(private http: HttpClient) {
  }

  getAll(params: any) {
    return this.http.get(URLS.API + 'cars/vehicleILStandardInfo', {withCredentials: true}).pipe(
      map((res: any) => {
          return res.data;
        }
      ));
  }


}
